import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    verifyMessage: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.VERIFY_PASSWORD_CHANGE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.VERIFY_PASSWORD_CHANGE_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.VERIFY_PASSWORD_CHANGE_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_SIGN_UP_STATUS:
      return {
        ...state,
        data: null,
        isProgress: false,
      };
    case homeConstants.RESET_ACCOUNT_CHANGE_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
